<p>period-comparation-progress works! {{ series[0].name }}</p>
